let webGLEnabled;

export const getWebGLEnabled = () => {
  if (webGLEnabled) {
    return webGLEnabled;
  }

  const canvas = document.createElement('canvas');
  const webgl =
    canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

  webGLEnabled = webgl instanceof WebGLRenderingContext;

  return webGLEnabled;
};
